export function DemandMonitoringHomeBreadcrumb() {
  return <span>Demand Monitoring</span>;
}
